import React from 'react'

import { Box, Button } from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { useIsSignupMotivationsEnabled } from 'hooks/useIsSignupMotivationsEnabled'
import { useIsBlackFridayPromotion } from 'routes/Home/useIsBlackFridayPromotion/useIsBlackFridayPromotion'
import { signupMotivationsSlug, postcodeSlug } from 'routes/Signup/signupConfig'

import { boxPricesBoxSizeSelected } from '../boxPricesActions'
import { discountInfographicCta, discountInfographicCtaBlackFriday } from '../boxPricesConfig'
import { BoxPricesWithAllPortionsType } from '../boxPricesModels'

type CtaType = Pick<BoxPricesWithAllPortionsType, 'activeNumPortion'>

export const Cta = ({ activeNumPortion }: CtaType) => {
  const dispatch = useDispatch()
  const isSignupMotivationsEnabled = useIsSignupMotivationsEnabled()
  const signupURL = isSignupMotivationsEnabled ? `${signupMotivationsSlug}` : `${postcodeSlug}`
  const boxPricesBoxSizeSelect = () =>
    dispatch(
      boxPricesBoxSizeSelected({
        numPersons: activeNumPortion,
        slug: signupURL,
        section: 'discount_offer',
      }),
    )

  const isBlackFridayPromotion = useIsBlackFridayPromotion()

  return (
    <Box>
      <Button
        data-testid="build-my-box-with-discount-cta"
        width={['311px', '311px', '568px']}
        height={['48px', '56px']}
        onClick={boxPricesBoxSizeSelect}
      >
        {isBlackFridayPromotion
          ? discountInfographicCtaBlackFriday.text
          : discountInfographicCta.text}
      </Button>
    </Box>
  )
}
